import React, { useState, useEffect } from 'react';
import { dashboardService } from '@/lib/dashboardService';
import { getCurrentUserOrganizationId } from '@/lib/data';

export function MobileDashboardDebug() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orgId, setOrgId] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        console.log('Loading dashboard data...');
        
        // Get organization ID
        const organizationId = await getCurrentUserOrganizationId();
        setOrgId(organizationId);
        console.log('Organization ID:', organizationId);
        
        if (!organizationId) {
          throw new Error('No organization ID found');
        }

        // Load dashboard data
        const dashboardData = await dashboardService.getDashboardData();
        console.log('Dashboard data loaded:', dashboardData);
        setData(dashboardData);
      } catch (err) {
        console.error('Error loading dashboard data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return <div>Loading dashboard data...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <h1>Mobile Dashboard Debug</h1>
      <p>Organization ID: {orgId}</p>
      <p>Data loaded: {data ? 'Yes' : 'No'}</p>
      {data && (
        <div>
          <h2>Members:</h2>
          <p>Total: {data.members?.counts?.total || 0}</p>
          <p>Recent: {data.members?.recent?.length || 0}</p>
          
          <h2>Events:</h2>
          <p>Total: {data.events?.stats?.total || 0}</p>
          <p>Upcoming: {data.events?.upcoming?.length || 0}</p>
          
          <h2>Raw Data:</h2>
          <pre style={{ fontSize: '12px', maxHeight: '400px', overflow: 'auto' }}>
            {JSON.stringify(data, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}